import React from 'react';
import { Faq } from './Faq';
import { FinalClose } from './FinalClose';
import { Footer } from './Footer';
import { Guarantee } from './Guarantee';
interface LateContentProps {
  onCta: () => void;
}

/** Lower-priority conversion content loaded only as visitors approach it. */
export function LateContent({
  onCta
}: LateContentProps) {
  return <>
      <Guarantee data-id="element-140" data-mp="3647tmwbokxtv" />
      <Faq data-id="element-141" data-mp="2ibzouerzad6a" />
      <FinalClose onCta={onCta} data-id="element-142" data-mp="2ibrcqp3ojbw5" />
      <Footer data-id="element-143" data-mp="2id2i2tcrwrpd" />
    </>;
}